import { writable } from "svelte/store";

export const users = writable({ loggedIn: false });
